import React from "react";

const STATUS_MAP = {
  OPN: { label: "Open", color: "primary" },
  INP: { label: "In Progress", color: "warning" },
  CRS: { label: "Resolved", color: "success" },
  CNR: { label: "Cancelled", color: "danger" },
  INV: { label: "Invoiced", color: "info" },
  NIV: { label: "Not Invoiced", color: "warning" },
};

export const getStatusMeta = (status) => {
  const normalized = String(status || "").toUpperCase();
  return STATUS_MAP[normalized] || {
    label: normalized || "No Status",
    color: "secondary",
  };
};

const formatDateTime = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);

  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);

  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export default function ActivityTimeline({ activities = [] }) {
  if (!Array.isArray(activities) || activities.length === 0) {
    return (
      <div className="text-center text-muted border rounded-3 bg-light p-4">
        No activity found for this inquiry.
      </div>
    );
  }

  return (
    <div className="activity-timeline position-relative">
      {activities.map((activity, index) => {
        const status = String(activity?.status || "").toUpperCase();
        const statusMeta = getStatusMeta(status);
        const createdAt = activity?.created_at ?? activity?.createdAt;
        const followupDate = activity?.followup_date ?? activity?.followupDate;
        const remark = activity?.remark ?? "";

        return (
          <div key={activity?.id ?? `${status}-${index}`} className="activity-item position-relative ps-4 pb-3">
            <span className="activity-dot position-absolute top-0 start-0 translate-middle-x rounded-circle bg-primary" />

            <div className="card border-0 shadow-sm activity-card">
              <div className="card-body p-3 p-md-3">
                <div className="d-flex flex-column flex-md-row justify-content-between gap-2 mb-2">
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    {status && (
                      <span className={`badge bg-${statusMeta.color}`}>{statusMeta.label}</span>
                    )}
                    <small className="text-muted">{formatDateTime(createdAt)}</small>
                  </div>
                  {followupDate ? (
                    <small className="text-muted">
                      Follow-up: <span className="fw-semibold text-dark">{formatDate(followupDate)}</span>
                    </small>
                  ) : null}
                </div>

                {remark ? (
                  <div className="activity-remark">{remark}</div>
                ) : null}
              </div>
            </div>
          </div>
        );
      })}

      <style>{`
        .activity-timeline::before{
          content:"";
          position:absolute;
          top:0;
          bottom:0;
          left:8px;
          width:2px;
          background:linear-gradient(to bottom,rgba(13,110,253,.45),rgba(13,110,253,.08));
        }
        .activity-item:last-child{padding-bottom:0!important}
        .activity-dot{
          width:14px;
          height:14px;
          margin-top:10px;
          background:#0d6efd;
          box-shadow:0 0 0 4px rgba(13,110,253,.12);
          z-index:1;
        }
        .activity-card{
          margin-left:8px;
          border-radius:14px;
          background:#fff;
        }
        .activity-remark{
          white-space:pre-wrap;
          word-break:break-word;
          color:#334155;
        }
        @media (max-width:575.98px){
          .activity-timeline::before{left:7px}
          .activity-card{margin-left:7px}
        }
      `}</style>
    </div>
  );
}
